import { Icon, IconProps } from '@chakra-ui/react';

export function EuroIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.3337 12.3333C8.66033 12.3333 7.21366 11.3867 6.49366 10H10.3337L11.0003 8.66667H6.05366C6.02033 8.44667 6.00033 8.22667 6.00033 8C6.00033 7.77333 6.02033 7.55333 6.05366 7.33333H10.3337L11.0003 6H6.49366C7.21366 4.61333 8.66699 3.66667 10.3337 3.66667C11.407 3.66667 12.3937 4.06 13.1537 4.71333L14.3337 3.53333C13.2737 2.58 11.867 2 10.3337 2C7.72033 2 5.50699 3.67333 4.68033 6H2.33366L1.66699 7.33333H4.37366C4.34699 7.55333 4.33366 7.77333 4.33366 8C4.33366 8.22667 4.34699 8.44667 4.37366 8.66667H2.33366L1.66699 10H4.68033C5.50699 12.3267 7.72033 14 10.3337 14C11.8737 14 13.2737 13.42 14.3337 12.4667L13.147 11.2867C12.3937 11.94 11.4137 12.3333 10.3337 12.3333Z" />
    </Icon>
  );
}
